"use client";

import H3 from "../H3";
import styles from "./styles.module.css";
import parse from "html-react-parser";
import DOMPurify from "isomorphic-dompurify";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";

export default function Tabs(props: any) {
  const [activeTab, setActiveTab] = useState(0);
  const [tabContent, setTabContent] = useState([""]);
  const [tabTitles, setTabTitles] = useState([""]);
  const [customTabs, setCustomTabs] = useState(false);
  const pathname = usePathname();
  const t = useTranslations(props.translations);

  useEffect(() => {
    handleSelectTab(0);
    const tabs: any[] = Object.values(props.content.content);
    const temp: string[] = [];
    tabs.forEach((tab) => temp.push(tab.tab));
    setTabTitles(temp);
    if(
      pathname.includes('smart-contracts-development') && props.sectionIndex === 0 ||
      pathname.includes('dapp-development') && props.sectionIndex === 0 ||
      pathname.includes('dezvoltare-contracte-inteligente') && props.sectionIndex === 0 ||
      pathname.includes('dezvoltare-aplicatii-descentralizate') && props.sectionIndex === 0 ||
      pathname.includes('developpement-de-contrats-intelligents') && props.sectionIndex === 0 ||
      pathname.includes('developpement-dApp') && props.sectionIndex === 0 ||
      pathname.includes('desenvolvimento-de-contratos-inteligentes') && props.sectionIndex === 0 ||
      pathname.includes('desenvolvimento-dApp') && props.sectionIndex === 0 ||
      pathname.includes('smart-contracts-entwicklung') && props.sectionIndex === 0 ||
      pathname.includes('dApp-entwicklung') && props.sectionIndex === 0
    ) {
      setCustomTabs(true)
    }
  }, []);

  useEffect(() => {
    const selectValues = props.content.content[`content${activeTab + 1}`];
    let finalTabContent: string[] = [];
    finalTabContent = Object.values(selectValues.content);
    const temp: string[] = [];
    finalTabContent.forEach((item: string) => temp.push(item));
    setTabContent(temp);
  }, [activeTab]);

  const handleSelectTab = (index: number) => {
    setActiveTab(index);
  };

  return (
    <div
      className={
        props.upperTabs
          ? styles["tabs-container-top-aligned"]
          : styles["tabs-container"]
      }
    >
      <div
        className={`${styles.tabs} ${
          props.upperTabs ? "flex-row flex-wrap md:flex-nowrap" : "flex-col"
        } ${props.shouldHaveGridTabs || customTabs ? "md:grid md:grid-cols-3 flex" : "flex"}`}
      >
        {tabTitles.map((tab: any, index: number) => {
          return (
            <div key={index} className={styles['tabs-wrapper']}>
              <div
                onClick={() => handleSelectTab(index)}
                className={
                  activeTab === index ? styles["selected-tab"] : styles.tab
                }
              >
                <H3
                  style={styles["selected-tab__h3"]}
                  text={"tab"}
                  translation={`${props.translations}.content${index + 1}`}
                />
              </div>
            </div>
          );
        })}
      </div>
      <div
        className={`${
          props.upperTabs ? "w-full" : "w-9/12"
        } h-[280px] overflow-scroll`}
      >
        {tabContent.map((tab: any, index: number) => {
          return (
            <div key={index} className={styles["content-container"]}>
              {parse(
                DOMPurify.sanitize(
                  t.raw(`content${activeTab + 1}.content.${index + 1}`)
                )
              )}{" "}
              <br />
              <br />
            </div>
          );
        })}
      </div>
    </div>
  );
}
